module.exports = __webpack_public_path__ + "img/nt116-00-81-1.asm.d991712d.jpg";